"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _theme = require("../../theme");

var _antd = require("antd");

var _icons = require("@ant-design/icons");

var _MenuComponent = _interopRequireDefault(require("../Menu/MenuComponent"));

var _excluded = ["className", "variant", "children", "menu"];

var _templateObject, _templateObject2;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var AppDropdown = (0, _styledComponents.default)(_antd.Dropdown)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  &.link-dropdown {\n    font-size: ", ";\n    line-height: 20px;\n    color: ", ";\n  }\n  .dropdown-caret-icon {\n    margin-left: 3px;\n  }\n  &.button-dropdown {\n    .ant-btn {\n      width: 32px;\n      background: ", ";\n      padding: 0;\n      line-height: 32px;\n      border-radius: 2px;\n      border: 0;\n      color: ", ";\n      box-shadow: none;\n      &:after {\n        box-shadow: none;\n        border: 0;\n      }\n    }\n  }\n"])), _theme.theme.font_size.size_l, _theme.theme.colors.anchor_blue, _theme.theme.colors.light_grey, _theme.theme.colors.black_secondary);
var DropdownMenu = (0, _styledComponents.default)(_MenuComponent.default)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  border: 1px solid ", ";\n  background: ", ";\n  box-shadow: ", ";\n  border-radius: 2px;\n  padding: 4px 0;\n  .ant-dropdown-menu-item {\n    font-size: ", ";\n    color: ", ";\n    padding: 8px 12px;\n    &:hover {\n      background: ", ";\n    }\n    & > {\n      a {\n        color: inherit;\n      }\n    }\n  }\n"])), _theme.theme.colors.grey, _theme.theme.colors.white, _theme.theme.shadows.dropdown, _theme.theme.font_size.size_l, _theme.theme.colors.black_secondary, _theme.theme.colors.light_grey);

var defaultMenu = /*#__PURE__*/_react.default.createElement(DropdownMenu, {
  type: "basic",
  multiple: false,
  mode: "inline",
  items: [{
    title: "Menu Item 1",
    disabled: false,
    key: "1"
  }, {
    title: "Menu Item 2",
    disabled: false,
    key: "2"
  }, {
    title: "Menu Item 3",
    disabled: false,
    key: "3"
  }],
  width: "300px"
});

function DropdownAnt(props) {
  var className = props.className,
      _props$variant = props.variant,
      variant = _props$variant === void 0 ? "button" : _props$variant,
      _props$children = props.children,
      children = _props$children === void 0 ? "Button" : _props$children,
      _props$menu = props.menu,
      menu = _props$menu === void 0 ? defaultMenu : _props$menu,
      rest = _objectWithoutProperties(props, _excluded);

  return /*#__PURE__*/_react.default.createElement(AppDropdown, _extends({
    overlay: menu,
    trigger: ["click"],
    placement: "bottomRight",
    className: "".concat(variant)
  }, rest), /*#__PURE__*/_react.default.createElement("a", {
    href: "/"
  }, variant === "link-dropdown" ? /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, children, /*#__PURE__*/_react.default.createElement(_icons.CaretDownOutlined, {
    className: "dropdown-caret-icon"
  })) : /*#__PURE__*/_react.default.createElement(_antd.Button, null, /*#__PURE__*/_react.default.createElement(_icons.EllipsisOutlined, null))));
}

var _default = DropdownAnt;
exports.default = _default;